import type { ReactElement } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import leadsSearchFiltersI18nKeys from "app/pages/sales-intelligence/modules/leads-search-filters/utils/i18n";

import { StyledSiteTagsBulkInvalidNotification, StyledSiteTagsBulkInvalidNotificationText } from "./styles";

type SiteTagsBulkInvalidNotificationProps = {
    invalidCount: number;
};

const SiteTagsBulkInvalidNotification = ({ invalidCount }: SiteTagsBulkInvalidNotificationProps): ReactElement => {
    const { translate } = useTranslate();

    return (
        <StyledSiteTagsBulkInvalidNotification data-automation="site-tags-bulk-invalid-notification">
            <StyledSiteTagsBulkInvalidNotificationText>
                {translate(leadsSearchFiltersI18nKeys.siteTagsBulkInvalidNotification(), {
                    count: invalidCount,
                })}
            </StyledSiteTagsBulkInvalidNotificationText>
        </StyledSiteTagsBulkInvalidNotification>
    );
};

export default SiteTagsBulkInvalidNotification;
